import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[ngModel][smart-float]'
})
export class SmartFloatDirective {

  @Input("decimals") decimals: number = 2;
  @Output() ngModelChange:EventEmitter<any> = new EventEmitter()
  
  private oldValue : string = "";

  constructor(private el: ElementRef) {
    if(this.el.nativeElement.value == ""){
      this.el.nativeElement.value = "0.00";
    }
    this.oldValue = this.el.nativeElement.value;
    this.ngModelChange.emit(this.el.nativeElement.value);
  }

  @HostListener('keyup', ['$event']) onKeyUp(event: any) {
    if(this.el.nativeElement.value != "" && ((event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode == 190 || event.keyCode == 110)) {
      if(isNaN(parseFloat(this.el.nativeElement.value)) || !event.key.match("\\d\|\\.")){
        this.el.nativeElement.value = this.oldValue;
      } else {
        this.oldValue = this.el.nativeElement.value;
      }
    } else {
      this.oldValue = this.el.nativeElement.value;
    }
    this.ngModelChange.emit(this.el.nativeElement.value);
  }

 
  @HostListener('focusout') onMouseEnter() {
    if(this.el.nativeElement.value != ""){
      if(!isNaN(parseFloat(this.el.nativeElement.value))){
        let val = "" + parseFloat(this.el.nativeElement.value).toFixed(this.decimals);
        this.el.nativeElement.value = val.replace(/,/, '.');
      } else {
        this.el.nativeElement.value = "";
      }
      this.oldValue = this.el.nativeElement.value;
      this.ngModelChange.emit(this.el.nativeElement.value);
    }
  }

}
